import React, { useEffect, useState } from "react";

const Soap = () => {
  // Utilisation de useState pour gérer l'état du compteur de bulles
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    // Fonction principale pour générer des bulles de savon
    function soapBubbles() {
      // Sélection de l'élément conteneur des bulles de savon
      const sodaContainer = document.querySelector(".soap-container");

      // Fonction pour créer une nouvelle bulle de savon
      const bubbleMaker = () => {
        // Création d'un élément span pour représenter la bulle de savon
        const bubble = document.createElement("span");
        bubble.classList.add("soap-bubble"); // Ajout de la classe CSS pour le style
        sodaContainer.appendChild(bubble); // Ajout de la bulle à l'élément conteneur

        // Génération aléatoire de la taille de la bulle
        const size = Math.random() * 100 + 50 + "px";
        bubble.style.height = size;
        bubble.style.width = size;

        // Positionnement aléatoire de la bulle dans le conteneur
        bubble.style.top = Math.random() * 100 + 50 + "%";
        bubble.style.left = Math.random() * 100 + "%";

        // Animation de déplacement horizontal de la bulle
        const plusMinus = Math.random() > 0.8 ? 1 : -1;
        bubble.style.setProperty(
          "--left",
          Math.random() * 100 * plusMinus + "%"
        );

        // Détection du type d'événement à utiliser en fonction du type d'appareil
        const isTouchDevice =
          "ontouchstart" in window || navigator.msMaxTouchPoints;
        const eventType = isTouchDevice ? "touchstart" : "click"; // Utilisation de "touchstart" sur les smartphones et "click" sur les ordinateurs

        // Gestion de l'événement de clic ou de toucher sur la bulle
        bubble.addEventListener(eventType, () => {
          setCounter((prevCounter) => prevCounter + 1); // Incrémentation du compteur de bulles
          bubble.remove(); // Suppression de la bulle lorsqu'elle est touchée
        });

        // Suppression automatique de la bulle après un délai
        setTimeout(() => {
          bubble.remove();
        }, 8000);
      };

      // Appel répété de la fonction bubbleMaker pour générer des bulles à intervalles réguliers
      setInterval(bubbleMaker, 300);
    }

    // Appel de la fonction principale lors du montage du composant
    soapBubbles();
  }, []);

  return (
    <div>
      {/* Élément conteneur des bulles de savon avec affichage du compteur */}
      <div className="soap-container">
        <h2>Cliquez sur les bulles pour les faire éclater</h2>
        <h4>{counter}</h4>
      </div>
    </div>
  );
};

export default Soap;
